import type { AnyBlock } from "@/types";

/** CD "What kind of drawings do I need?" — a 2×2 grid alternating explanatory
 *  text and a sample drawing (planning, then building-regulation). Fixed-layout
 *  designed section; copy + images come from props (CD defaults below). */
interface CdDrawingsProps {
  eyebrow?: string;
  heading?: string;
  planning_title?: string;
  planning_body?: string[];
  planning_image_url?: string;
  buildreg_title?: string;
  buildreg_body?: string[];
  buildreg_image_url?: string;
}

const DEFAULTS = {
  eyebrow: "The process",
  heading: "What kind of drawings do I need?",
  planning_title: "Planning drawings",
  planning_body: [
    "Planning drawings are required for your planning application to show the planners what you are going to build. They must be drawn to scale and show both plan and elevation views, and include a map showing the location of the property.",
    "Some types of small extension do not require planning permission, as they are considered permitted development.",
  ],
  planning_image_url: "/cd/planning.webp",
  buildreg_title: "Building regulation drawings",
  buildreg_body: [
    "Building regulation drawings tell the builder how to build your extension. Builders will often ask for this type of drawing before providing a quote, as it helps them calculate the cost of the materials.",
    "These drawings can also be used to obtain building control approval of the work.",
  ],
  buildreg_image_url: "/cd/buildreg.webp",
};

export function CdDrawingsBlock({ block }: { block: AnyBlock }) {
  const p = (block.props ?? {}) as CdDrawingsProps;
  const planningBody = p.planning_body ?? DEFAULTS.planning_body;
  const buildregBody = p.buildreg_body ?? DEFAULTS.buildreg_body;

  return (
    <section className="block cd-drawings">
      <p className="eyebrow">{p.eyebrow ?? DEFAULTS.eyebrow}</p>
      <h2 className="cd-drawings__title">{p.heading ?? DEFAULTS.heading}</h2>
      <div className="cd-drawings__grid">
        <div className="cd-drawings__text">
          <h3>{p.planning_title ?? DEFAULTS.planning_title}</h3>
          {planningBody.map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>
        <img
          className="cd-drawings__img"
          src={p.planning_image_url ?? DEFAULTS.planning_image_url}
          alt=""
          loading="lazy"
        />
        <img
          className="cd-drawings__img"
          src={p.buildreg_image_url ?? DEFAULTS.buildreg_image_url}
          alt=""
          loading="lazy"
        />
        <div className="cd-drawings__text">
          <h3>{p.buildreg_title ?? DEFAULTS.buildreg_title}</h3>
          {buildregBody.map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>
      </div>
    </section>
  );
}
